"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContent = void 0;
var _types = require("../../types");
const getContent = ({
  newsletterSubsciptionConfiguration,
  status
}) => {
  const {
    submitDialog,
    subscribedDialog,
    errorDialog
  } = newsletterSubsciptionConfiguration ?? {};
  const content = {
    title: submitDialog?.headline,
    icon: 'info',
    text: submitDialog?.text,
    showForm: true,
    showButton: true,
    buttonText: submitDialog?.subscribeButtonText,
    buttonAction: _types.ButtonAction.Submit,
    ppText: submitDialog?.privacyPolicyText ?? '',
    ppLinkText: submitDialog?.privacyPolicyUrlText ?? '',
    ppUrl: submitDialog?.privacyPolicyUrl ?? '',
    invalidEmailLabel: submitDialog?.invalidEmailLabel ?? 'Invalid email',
    emailLabel: submitDialog?.emailLabel ?? 'Email'
  };
  if (status === _types.SubscriptionProcessStatus.Subscribed) {
    content.title = subscribedDialog?.headline;
    content.icon = 'success';
    content.text = subscribedDialog?.text;
    content.showForm = false;
    content.showButton = false;
    content.buttonText = '';
    content.buttonAction = _types.ButtonAction.None;
    content.ppText = '';
    content.ppLinkText = '';
    content.ppUrl = '';
  }
  if (status === _types.SubscriptionProcessStatus.Failed) {
    content.title = errorDialog?.headline;
    content.icon = 'error';
    content.text = '';
    content.showForm = false;
    content.showButton = true;
    content.buttonText = errorDialog?.buttonText;
    content.buttonAction = _types.ButtonAction.Reset;
    content.ppText = '';
    content.ppLinkText = '';
    content.ppUrl = '';
  }
  return content;
};
exports.getContent = getContent;
